/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { styled } from '@mui/material/styles';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Research from '../../funtComponents/research';
import ExpandUser from '../../funtComponents/incomingCalls/audioExpand';
import PopUp from '../../funtComponents/popUpAnexos';
import * as redux from '../../../redux/constanst/index';
import ListReport from '../models/listReport';
import ListIncoming from '../../funtComponents/incomingCalls/listIncoming';
import { llamadasEntrantes, llamadasSalientes, mapStateToProps, llamadasErrores, arreglo } from '../models/buscar';
import { View, TitleTopBar } from '../incomingCalls/incomElements'
import LoadScreen from '../../funtComponents/loadScreen';
import { useDispatch } from 'react-redux';
import { connect } from 'react-redux';
import PopUpPDF from '../../funtComponents/popUpDownload';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));


function EntrantesPage(props) {
  const [anexosState] = React.useState("Anexos")
  const [changeOptions] = React.useState("Add")

  
  const [load, setLoad] = React.useState(true)
  const [openLoad, setOpenLoad] = React.useState(false);
  const dispatch = useDispatch();

    //interactuan con el PopUp
    const [openpop, setOpenPop] = React.useState(false);

    const resuelto = arreglo(props.entrantes, props.rightAnexos)
  

    const handleClickOpen = (item) => {
      setOpenPop(true);
    };
    const handleClose = () => {
      setOpenPop(false);
    };

  React.useEffect(() => {
    
     
    if(load === true){
      var arr = Object.values(props.entrantes);
      if(arr.length !== 0){
        setLoad(false)
      }
    } 

    
    /* pushEntrantes(props.entrantes);
    pushSalientes(props.salientes); */
  },[props.entrantes])

  const handlerSearch = async ( diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos) => {
    
    const errores =  llamadasErrores("nada", 0, diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos);
    if((typeof errores) !== "number"){
      dispatch({ type: redux.USER_ERRORSTATE_STATE_CHANGE, errorState: errores.mensaje })
      dispatch({ type: redux.USER_LOADERROR_STATE_CHANGE, loadError: true })
      
    }
    if(errores === 200){
      await dispatch({ type: redux.USER_SALIENTES_STATE_CHANGE, salientes: [] })

      await dispatch({ type: redux.USER_ENTRANTES_STATE_CHANGE, entrantes: [] })
      setOpenLoad(true);
      const respEntrantes = await llamadasEntrantes("entrantes", 0, diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos);
      const respSalientes = await llamadasSalientes("salientes", 0, diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos);
      if(respSalientes?.type === "SQL" || respEntrantes?.type === "SQL" ){
        handlerSearch(diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos)
        return
      }
      await dispatch({ type: redux.USER_SALIENTES_STATE_CHANGE, salientes: respSalientes })
      
      await dispatch({ type: redux.USER_ENTRANTES_STATE_CHANGE, entrantes: respEntrantes })
      setOpenLoad(false);
    }
  
    
  
  } 

 

  return (

    <View style={GnralContainer}>
      <View style={HeaderContain}>
        <View style={HeaderTopBar}>
          <EqualizerIcon style={IconTopBar} />
          <TitleTopBar style={TitleTopBarStyle}>
            Entrantes
          </TitleTopBar>
        </View>
        {changeOptions === "Add" ? <View style={SearchContain}>
          <PopUp btnText={anexosState} />
          <View style={SearchBar}>
            <Research />
          </View>
          <View style={SearchBtnContain}>
            <Button
             onClick={() => handlerSearch(props.dateChangeInicio.dia, props.dateChangeInicio.mes, props.dateChangeFinal.dia, props.dateChangeFinal.mes, props.dateChangeInicio.year, props.dateChangeFinal.year, Object.values(props.rightAnexos) )}
              style={SearchBtn}
              variant="contained" color="success" >
              <p style={{ fontSize: 10 }}>filtrar</p>
            </Button>
          </View>
        </View>
          :
          <View style={BlankView} />}
      </View>
      <View style={BodyContain} >
        <Box sx={BodyWrapper}>
          <Grid container spacing={2} columns={10}>
            <Grid item xs={5} >
              <Item>
                <ListReport />
              </Item>
            </Grid>
            <Grid item xs={5}>
              <Item>
                <ListIncoming />
              </Item>
            </Grid>
            <Grid item xs={10}>
              <Item>
                <View style={ItemTitleBar}>
                  <h4 >Llamadas Entrantes (Por Usuario)</h4>
                </View>
                <ExpandUser />
              </Item>
            </Grid>
          </Grid>
        </Box>

        <PopUpPDF pdfContent={resuelto} openpop={openpop} setOpenPop={setOpenPop} handleClickOpen={handleClickOpen} handleClose={handleClose} />

      <LoadScreen setOpenLoad={setOpenLoad} openLoad={openLoad}  />
      </View>
    </View >
    
  );
}



export default connect(mapStateToProps, null)(EntrantesPage);

const GnralContainer = {
  height: '100%',
  display: "flex",
  width: '100%',
  backgroundColor: "#f6f6f6",
  borderTopLeftRadius: 20,
  borderTopRightRadius: 20,
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
}

const HeaderContain = {
  flexDirection: 'row',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start'
}

const HeaderTopBar = { 
  flexDirection: 'row', 
  minWidth: 150, 
  width: '100%', 
  display: 'flex', 
  flex: 1.5, 
  alignItems: 'center', 
  justifyContent: 'flex-start' 
}

const IconTopBar = { 
  marginLeft: 10, 
  marginBottom: 10, 
  color: 'rgba(229, 29, 29, 0.7)' 
}

const TitleTopBarStyle = { 
  fontSize: 15, 
  color: 'rgba(229, 29, 29, 0.7)', 
  alignSelf: 'flex-start', 
  marginLeft: 15, 
  marginBottom: 10 
}

const SearchContain = { 
  paddingLeft: 30, 
  flexDirection: 'row', 
  height: '100%', 
  width: '100%', 
  display: 'flex', 
  flex: 11, 
  alignItems: 'center', 
  justifyContent: 'center' 
}

const SearchBar = { 
  flexDirection: 'row', 
  height: '100%', 
  width: '100%', 
  display: 'flex', 
  flex: 5, 
  alignItems: 'center', 
  justifyContent: 'center' 
}

const SearchBtnContain = { 
  display: 'flex', 
  flex: 2, 
  flexDirection: 'row' 
}

const SearchBtn = { 
  marginLeft: 10,
  background: 'rgba(229, 29, 29, 0.7)' 
}

const BlankView = { 
  flexDirection: 'row', 
  height: '100%', 
  width: '100%', 
  display: 'flex', 
  flex: 4, 
  alignItems: 'center', 
  justifyContent: 'center' 
}

const BodyContain = {
  height: 'auto',
  display: "flex",
  width: '100%',
  backgroundColor: 'rgba(238, 238, 238, 0.9)',
  marginTop: 10,
  borderTopLeftRadius: 20,
  borderTopRightRadius: 20,
  padding: 10,
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
}

const BodyWrapper = { 
  flexGrow: 1, 
  width: '100%', 
  height: '100%',
}

const ItemTitleBar = {
  height: 50, 
  display: 'flex', 
  alignItems: 'center', 
  justifyContent: 'flex-start',
   alignContent: 'center',
  borderTopLeftRadius: 5, 
  borderTopRightRadius: 5, 
  paddingLeft: 20
}
